var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"uk-button-dropdown",class:{'uk-open': !!this.opened},on:{"mouseover":_vm.maybe_open,"mouseleave":_vm.maybe_close}},[_c('base-button',_vm._b({on:{"click":_vm.toggle}},'base-button',_vm.$props,false),[_vm._t("default")],2),_c('div',{staticClass:"uk-dropdown uk-dropdown-small"},[_vm._t("dropdown")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }